import { NgModule } from '@angular/core';
import { ForgotResetModule } from './forgot-reset.module';


@NgModule({
    imports: [
        ForgotResetModule
    ]
})
export class PageForgotResetModule {

}
